import { Flash16 } from '@carbon/icons-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { NotifyViaAutomationMeta } from 'api/notifications/meta/automations-meta';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { useUser } from 'hooks/use-user';
import { fullName } from 'utils/full-name';

interface Props {
  meta: NotifyViaAutomationMeta;
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: start;
  .ck.ck-content {
    padding: 0;
  }
  [class*='rich-text-editor'] {
    width: 100%;
    background: transparent;
  }
  --rte-min-height: 0;
  --rte-content-padding: 0;
  --rte-readonly-content-padding: 0;
  .ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
    min-height: 0 !important;
    background: transparent;
    * {
      cursor: default !important;
    }
  }
  cursor: default;
  background: transparent;
`;

const FlashIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-03);
`;

const AutomationTitleWrapper = styled.span`
  font-weight: bold;
`;

const FullNameWrapper = styled.span`
  color: var(--blue-60);
  margin: 0 var(--spacing-02);
`;

export const NotifySomeoneViaAutomationLineItem: React.FC<Props> = ({
  meta,
}) => {
  const userProfileInfo = useUser();

  const name = fullName(userProfileInfo.user);

  return (
    <Wrapper>
      <FlashIconWrapper>
        <Flash16 color="var(--orange-60)" />
      </FlashIconWrapper>
      <AutomationTitleWrapper>
        <FormattedMessage id="automations" />
        <FormattedMessage id=":" />
      </AutomationTitleWrapper>
      <FullNameWrapper>
        <FormattedMessage id="@" />
        {name}
      </FullNameWrapper>
      <RichTextEditor readonly data={meta?.note ?? '<p></p>'} />
    </Wrapper>
  );
};
